/**
 *  @class
 *  @function LightSwitch
 */
if (!customElements.get('light-switch')) {
  class LightSwitch extends HTMLElement {
    constructor() {
      super();
    }
    
    connectedCallback() {
      this.button = this.querySelector('.light-switch--button');
      this.lightOff = this.querySelector('.light-off');
      this.lightOn = this.querySelector('.light-on');
      this.isLightOn = false;
      
      if (this.button) {
        this.button.addEventListener('click', () => this.toggleLight());
      }
      
      // 初始状态：灯是关闭的
      this.updateLightState();
    }
    
    toggleLight() {
      this.isLightOn = !this.isLightOn;
      this.updateLightState();
    }
    
    updateLightState() {
      if (this.isLightOn) {
        // 灯亮
        this.lightOff.style.opacity = '0';
        this.lightOn.style.opacity = '1';
        this.lightOn.classList.add('light-animation');
        this.button.textContent = this.button.dataset.offText || '关灯';
      } else {
        // 灯灭
        this.lightOff.style.opacity = '1';
        this.lightOn.style.opacity = '0';
        this.lightOn.classList.remove('light-animation');
        this.button.textContent = this.button.dataset.onText || '开灯';
      }
    }
  }
  
  customElements.define('light-switch', LightSwitch);
} 